const BOOKMARKED_ADS_LS = 'favorites';

export default BOOKMARKED_ADS_LS;
